import { PuffLoader, SyncLoader } from 'react-spinners';
import { cn } from 'utils/commonUtils';

const LoadingSpinner = ({ color = "#65acae", size = 42, className = "" }) => {
    return (
        <div className={cn(`tw-h-[50vh] tw-p-5 tw-m-5 tw-flex tw-items-center tw-justify-center`, className)}>
            <PuffLoader className="tw-m-auto" color={color} size={size} />
        </div>
    );
};

export default LoadingSpinner;
